import { Namespaces } from 'redux/namespaces'

export const NewsTypes = {
    SET_NEWS_ITEM: `${Namespaces.NEWS}_SET_NEWS_ITEM`
}